import { getParamsFormObject } from 'utils';
import axiosClient from 'utils/axios';

// Admin flight API. Contract: docs/flight/api-contract.md, "Admin routes".
const endPoint = '/flight-bookings';

export default {
  async getFlightBookings(payload) {
    // A copy: getParamsFormObject deletes empty keys from the object it gets.
    const params = getParamsFormObject({ ...payload });
    const response = await axiosClient.get(`${endPoint}${params}`);
    return response.data;
  },

  async getFlightBookingDetail(id) {
    const response = await axiosClient.get(`${endPoint}/${id}`);
    return response.data;
  },

  // The e-ticket is an HTML page, not a JSON envelope; errors still come as JSON.
  async getFlightBookingETicket(id) {
    const response = await axiosClient.get(`${endPoint}/${id}/eticket`, { responseType: 'text' });
    return response.data;
  },

  // action: cancel | void | refund/calculate | refund/confirm | refund/request | retry-issue
  // | mark-refunded | resolve-duplicate-payment | resolve-amount-mismatch | resolve-seat-change
  // | mark-exchange-refunded | resolve-schedule-change | resolve-extras | sync
  async postFlightBookingAction(id, action, body) {
    const response = await axiosClient.post(`${endPoint}/${id}/${action}`, body);
    return response.data;
  },

  async getFlightSystems() {
    const response = await axiosClient.get('/flight-systems');
    return response.data;
  },

  async getFlightSetting() {
    const response = await axiosClient.get('/flight-settings');
    return response.data;
  },

  async updateFlightSetting(payload) {
    const response = await axiosClient.put('/flight-settings', payload);
    return response.data;
  },

  // payload: { from, to, system, groupBy: 'day' | 'month' }
  async getFlightRevenue(payload) {
    const params = getParamsFormObject({ ...payload });
    const response = await axiosClient.get(`/flight-revenue${params}`);
    return response.data;
  },

  // No query: today (Vietnam day) and monthToDate (Vietnam month so far).
  async getFlightDashboard() {
    const response = await axiosClient.get('/flight-dashboard');
    return response.data;
  },
};
